var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"subLabel"},[_vm._v(_vm._s(_vm.subLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }